import React, {ReactNode} from 'react'
import { Card } from 'react-bootstrap'
import * as components from '../../components'
import { TicketListPage } from '../Tickets'
import { VouchersPage } from '../VouchersPage'
import moment from 'moment'

const getDefaultFilters = () => ({
  today: moment().format('YYYY-MM-DD'),
  tomorrow: moment().add(1, 'days').format('YYYY-MM-DD'),
})

const renderCardContent = (order: number) => {
  const { today, tomorrow } = getDefaultFilters()

  const configMap: Record<number, ReactNode> = {
    1: (
      <TicketListPage
        defaultFilters={{ created_at_after: today, page: 1 }}
        showOnlyPages
      />
    ),
    2: (
      <TicketListPage
        defaultFilters={{ closed_on_after: today, page: 1 }}
        showOnlyPages
      />
    ),
    3: (
      <VouchersPage
        defaultFilters={{ created_at_after: today, page: 1 }}
        showOnlyPages
      />
    ),
    4: (
      <TicketListPage
        defaultFilters={{ delivery_at_after: today, page: 1 }}
        showOnlyPages
      />
    ),
    5: (
      <TicketListPage
        defaultFilters={{
          expected_delivery_time_after: today,
          expected_delivery_time_before: tomorrow,
          page: 1,
          status_in:
            'Registered,Under Progress,Ready,Hold,Ready For Pickup',
        }}
        showOnlyPages
      />
    ),
    6: (
      <TicketListPage
        defaultFilters={{ page: 1, escalation: 1 }}
        showOnlyPages
      />
    ),
    7: (
      <TicketListPage
        defaultFilters={{ page: 1, escalation: 2 }}
        showOnlyPages
      />
    ),
    8: (
      <TicketListPage
        defaultFilters={{ page: 1, escalation: 3 }}
        showOnlyPages
      />
    ),
  }

  return configMap[order] || null
}

export const DashboardCard = ({
  heading,
  value,
  order,
  style,
}: {
  heading: string
  value: number | string
  order: number
  style?: React.CSSProperties
}) => {
  return (
    <div style={{ display: 'flex', flexGrow: 4, margin: '.5rem', ...style }}>
      <Card style={{ width: '100%' }} key={heading} border="dark">
        <Card.Header className="card-header bg-dark text-white card-header">
          {heading}
        </Card.Header>
        <Card.Body className="text-center">
          <components.Slider
            header={heading}
            className="border border-white bg-transparent text-dark btn-primary-outline"
            title={<span className="display-2">{value}</span>}
          >
            {renderCardContent(order)}
          </components.Slider>
        </Card.Body>
      </Card>
    </div>
  )
}
